import { ProductsQuery } from "@modules/products/queries/ProductsQuery";
import { ProductsServiceInterface } from "@modules/products/services/ProductsServiceInterface";
import { filter, map, Observable, take, tap } from "rxjs";

import { ProductSdkDto } from "../types";
import { mapProductToSdkDto } from "../utils/mapProductToSdkDto";

export class ProductsStackServiceWrapper {
    constructor(
        private readonly productsService: ProductsServiceInterface,
        private readonly productsQuery: ProductsQuery
    ) {}

    /**
     * Adds a product to the fetching queue and returns an Observable that emits the product once it's loaded.
     *
     * @param productId - ID of the product to fetch
     * @returns Observable that emits the loaded product
     */
    addProductForFetching(productId: number): Observable<ProductSdkDto> {
        return this.productsQuery.selectProduct(productId).pipe(
            tap((product) => {
                if (!product) {
                    this.productsService.addProductForFetching(productId);
                }
            }),
            filter((product) => product !== null),
            take(1),
            map(mapProductToSdkDto)
        );
    }

    /**
     * Adds a product with quantity rules to the fetching queue.
     *
     * @param productId - ID of the product to fetch with quantity rules
     */
    addProductWithQuantityRulesForFetching(productId: number): void {
        this.productsService.addProductWithQuantityRulesForFetching(productId);
    }
}
